export const getItemDisplayName = (
  itemName: string,
  type: 'products' | 'themes',
  t: (key: string) => string,
) => {
  const translated = t(`${type}.${itemName}`)
  // If translation is missing, t() returns the key itself
  return translated === `${type}.${itemName}` ? itemName : translated
}
